import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy, CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { PagesModule } from './pages/pages.module';

import { ManagerModule } from './manager/manager.module';
import {
  CoreService,
  BackendService,
  AuthenticationService,
  InterceptorService,
  SettingsService,
  StorageService,
  AuthguardService,
  CaptchaService,

  ReportsService

} from './shared';


@NgModule({
  declarations: [
    AppComponent, 
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    PagesModule,
    //AdminModule,
    ManagerModule

  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },

    CoreService,
    BackendService,
    AuthenticationService,
    SettingsService,
    StorageService,
    AuthguardService,
    CaptchaService,

    ReportsService

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
